import { render } from "./CardComponent.vue?vue&type=template&id=9bd470ae&scoped=true"
const script = {}

import "./CardComponent.vue?vue&type=style&index=0&id=9bd470ae&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9bd470ae"]])

export default __exports__